import React from 'react';
import * as logger from '@happyreturns/jscommons';
import PropTypes from 'prop-types';
import { logMarketingLinkClick } from '../analytics';

function MarketingBox(props) {
  return (
    <div className="branded-tracking-content-column2">
      <div
        className="marketing-box"
        data-cy="marketing-box-image"
        onClick={() => {
          // we shouldn't log anything/provide feedback if there's no marketing URL provided
          if (!props.marketingURL) return;
          logger.Info('User clicked marketing image');

          logMarketingLinkClick();

          // open page specified by prop in a new tab
          window.open(props.marketingURL, '_blank');
        }}
        style={{
          backgroundImage: `url(${props.marketingImageURL})`,
          cursor: props.marketingURL ? 'pointer' : 'auto',
        }}
      ></div>
    </div>
  );
}
MarketingBox.propTypes = {
  // url to open when user clicks on marketing box
  marketingURL: PropTypes.string.isRequired,

  // image to use as background for box
  // XXX: should we add error handling code for if this url is not a valid image?
  marketingImageURL: PropTypes.string.isRequired,
};

export default MarketingBox;
